import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../common/services/auth.service';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from '../../../common/state/app.state';
import { WebsocketService } from '../../../common/services/websocket.service';
import { HoldingsTableService } from '../../../common/services/holdings-table.service';
import { SetSelectedHoldingData } from '../../../common/state/actions/holdings.actions';
import { NotificationInfoService } from '../../../common/services/notification-info.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { DocumentHelper } from 'src/app/modules/acbcr/components/common/helper/document-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  notificationItems = [];
  languages: Array<{
    id: number,
    flag?: string,
    name: string
  }>;
  selectedLanguage: {
    id: number,
    flag?: string,
    name: string
  };

  connectionOpened = false;
  necitite = 0;
  username;

  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<ApplicationState>,
    private websocketService: WebsocketService,
    private notificationService: NotificationInfoService,
    private holdingService: HoldingsTableService,
    private helperDataService: HelperDataService,
  ) {}

  ngOnInit() {
    this.username = UIHelper.username();

    if (!this.connectionOpened) {
      this.connectionOpened = true;
      this.websocketService.openConnection();
    }

    this.websocketService.messagesReceived.subscribe(
      response => {
        if (response) {
          this.necitite = response['necitite'];
          this.notificationItems = response['notificari'].map((item) => {
            item.link_documente = DocumentHelper.link_documente(item);
            return item;
          });
        }
      }
    )

    // Set Farmer Holding (Exploatatie)
    if (UIHelper.isFermier()) {
      this.store.pipe(select(getSelectedHolding))
      .subscribe((response: any) => {
        if (! response) {
          this.holdingService.getHoldingAPI({})
            .subscribe(response => {
              if (response?.result) {
                let exploatatie = response.result[0];
                this.store.dispatch(new SetSelectedHoldingData(exploatatie));
              }
          });
        }
      });
    }
  }

  onClickNotification(notification) {
    if (notification['citit']) {
      return;
    }

    let req_params = {
      id: notification['id']
    }

    this.notificationService.marcheazaCitit(req_params)
      .subscribe({
        next: () => {
          notification['citit'] = true;
          this.necitite -= 1;
        }
      });
  }

  onClickClopotel() {
    if (0 == this.necitite) {
      return;
    }

    this.notificationService.clopotel()
      .subscribe({
        next: () => {
          this.necitite = 0;
        }
      });
  }

  downloadNotificari() {
    this.notificationService.downloadAPI()
      .subscribe({
        next: (response) => {
          let now = UIHelper.now();
          let fisier = `Notificari_${now}.xls`;
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);
        }
      });
  }

  /**
   * Change the language
   * @param language language
   */
  changeLanguage(language) {
    this.selectedLanguage = language;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu() {
    document.body.classList.toggle('sidebar-enable');
  }

  /**
   * Logout the user
   */
  logout() {
    if (this.connectionOpened) {
      this.websocketService.closeConnection();
      this.connectionOpened = false;
    }

    this.authService.logout();
    this.router.navigateByUrl('/login');
    this.notificationItems = [];
    localStorage.removeItem('link-exploatatie');
  }
}
